import { DomManipulationService } from './../../../../modules/shared/services/dom-manipulation.service';
import { PurchasesService } from './../../../../inventory/purchases/purchases.service';
import { setSavedSearchValueDateType } from 'src/app/misc/saved-searches/helpers/prepare-saved-searh-filter.helper';
import { FormControlListIds, getFormControlNameById } from './../../../../modules/shared/constants/formcontrol-list.constants';
import { SharedTemplateService } from 'src/app/modules/shared/services/template.service';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { LeadAccountUpdateFieldsModel } from 'src/app/misc/workflow/models/lead-account-update-fields.models';
import { ChatFacade } from './../../../campaign/components/chat/chat.facade';
import { FormControlList } from './../../../../cases-v2/constants/form-control.constant';
import { DocumentViewerService } from './../../../../modules/shared/services/document-viewer.service';
import { MyDocumentsService } from './../../../../profile/my-documents/my-documents.service';
import { EmailTemplateService } from './../../../../configurations/system/services/email-template.service';
import { AccountModuleId, ContactModuleId, EstimateOrderModuleId, InvoiceOrderModuleId, LeadModuleId, LocationModuleId,
    OpportunityModuleId, ProductModuleId, SOModuleId, TaskModuleId, VendorModuleId,
    PurchaseOrderModuleId,BillOrderModuleId,VendorReturnModuleId,VendorCreditModuleId,BillPaymentModuleId } from './../../../../modules/shared/constants/modules.constant';
import { AppMainService } from './../../../../app-main.service';
import { customFieldTagRegex } from './../../../../modules/shared/constants/custom-field-tag.regex';
import { SavedSearchNS } from '../../../saved-searches/models/saved-search.models';
import { WorkflowService } from './../../services/workflow.service';
import { NotificaitonEmailTemplateModel, NotificationEmailTemplateFields } from './../../models/notification-email-template.model';
import { FormErrorHandler } from '../../../../modules/shared/helpers/form-error-handler.helper';
import { AppMainComponent } from '../../../../app.main.component';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { WorkflowModelsNS } from '../../models/add-update-workflow.models';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { fieldTagsValidator } from '../../../../modules/shared/validators/field-tags.validator';
import { ConfigurationService } from '../../../../configurations/configurationService';
import { Status } from 'src/app/modules/shared/models/status';
import { uploadFiles, validateFiles } from 'src/app/modules/shared/upload-files';
import { MessageService } from 'primeng/api';
import { saveAs } from "file-saver";
import { WF_VENDOR_UPDATE_FIELDS } from '../../models/workflow-vendor-fields.constants';
import Quill from 'quill';
import QuillBetterTablePlus from 'quill-better-table-plus';
import { EDITOR_COLORS } from '../../../../modules/shared/constants/user-preference.constant';
import { addInlineStyles } from 'src/app/modules/shared/helpers/add-inline-styles.helper';
import { environment } from 'src/environments/environment';
Quill.register({
    'modules/better-table-plus': QuillBetterTablePlus
}, true);
@Component({
  selector: 'app-workflow-email-add-dialog',
  templateUrl: './workflow-email-add-dialog.component.html',
  styleUrls: ['./workflow-email-add-dialog.component.scss'],
  providers: [ChatFacade]
})
export class WorkflowEmailAddDialogComponent implements OnInit, OnDestroy, OnChanges {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @ViewChild('editor') editor: any;
    @ViewChild('emailSubject') emailSubject: any;
    editorComponent: any;

    @Input() viewOnly: boolean = false;
    @Input() displayAddEmail: boolean = false;
    @Input() selectedActionEmail: WorkflowModelsNS.WorkflowAddEditActionEmail = null;
    @Input() parentModules: SavedSearchNS.IObjectType[] = [];
    @Input() selectedParentModule: SavedSearchNS.IObjectType;
    @Input() parentTemplates: SavedSearchNS.ITemplate[] = [];
    @Input() selectedParentTemplate: SavedSearchNS.ITemplate;
    @Input() selectedActionModule: any = null;
    @Input() assoModules: any;
    @Input() workflowType: number = WorkflowModelsNS.WorkflowTypeEnum.EVENT_BASED;
    @Input() notificationType: number = WorkflowModelsNS.WorkflowNotificationTypeEnum.EMAIL;
    @Output() dialogClosed = new EventEmitter<boolean>();
    @Output() emailSaved = new EventEmitter<WorkflowModelsNS.WorkflowAddEditActionEmail>();

    selectedModule: { objectId: number, name: string } = null;
    selectedChannelId: number = 0;
    workflowEmailRecipientType = WorkflowModelsNS.EmailRecipientType;

    mimeTypes = [
        { extension: "csv", value: "text/csv" },
        { extension: "doc", value: "application/msword" },
        { extension: "docx", value: "application/msword" },
        { extension: "gif", value: "image/gif" },
        { extension: "jpeg", value: "image/jpeg" },
        { extension: "jpg", value: "image/jpeg" },
        { extension: "png", value: "image/png" },
        { extension: "pdf", value: "application/pdf" },
        { extension: "ppt", value: "application/vnd.ms-powerpoint" },
        { extension: "pptx", value: "application/vnd.ms-powerpoint" },
        { extension: "rar", value: "application/x-rar-compressed" },
        { extension: "xls", value: "application/msexcel" },
        { extension: "xlsx", value: "application/msexcel" },
        { extension: "zip", value: "application/zip" },
        { extension: "txt", value: "text/plain" }
    ];
    allowedExtensions = ['.pdf', '.csv', '.txt', '.xlsx', '.xls', '.docx', '.doc', '.png', '.jpg', '.jpeg', '.ppt', '.pptx', '.gif', '.zip']; // For the attachment files
    attachments: WorkflowModelsNS.EmailTemplateAttachments[] = [];
    displayFilePreview: boolean = false;
    currentFile: any = null;

    senderReciever: any[] = [
        {
            name: 'Sender',
            field: 'sender',
            custom: true
        },
        {
            name: "Receiver's First name",
            field: 'receiverFirstName',
            custom: true
        },
        {
            name: "Receiver's Last name",
            field: 'receiverLastName',
            custom: true
        },
        {
            name: 'DetailedHyperLink',
            field: 'DetailedHyperLink',
            custom: true
        }
    ];

    //Task Data
    emailAddEditHeader: 'Add Email' | 'Edit Email' | 'View Email' | 'Add Whatsapp Alert' | 'Edit Whatsapp Alert' | 'View Whatsapp Alert' = 'Add Email';
    emailTypeName: 'Email' | 'Whatsapp Alert' = 'Email';
    emailAddData: WorkflowModelsNS.WorkflowAddEditActionEmail;
    addedFieldTags: string[] = [];


    defaultEmail: string = "Account Email";
    allAssignedTypes = [
        {
            id: WorkflowModelsNS.WorkflowEmailAssignedType.User,
            name: 'Users',
            label: 'User',
            activeModules: [LeadModuleId,AccountModuleId,OpportunityModuleId,VendorModuleId,TaskModuleId,
                LocationModuleId,ProductModuleId,InvoiceOrderModuleId,SOModuleId,EstimateOrderModuleId,
                PurchaseOrderModuleId,BillOrderModuleId,VendorReturnModuleId,VendorCreditModuleId,BillPaymentModuleId],
        },
        {
            id: WorkflowModelsNS.WorkflowEmailAssignedType.Lead,
            name: 'Leads',
            label: 'Lead',
            activeModules: [LeadModuleId]
        },
        {
            id: WorkflowModelsNS.WorkflowEmailAssignedType.Account,
            name: 'Accounts',
            label: 'Account',
            activeModules: [AccountModuleId,OpportunityModuleId,InvoiceOrderModuleId,SOModuleId,EstimateOrderModuleId]
        },
        {
            id: WorkflowModelsNS.WorkflowEmailAssignedType.Vendor,
            name: 'Vendors',
            label: 'Vendor',
            activeModules: [VendorModuleId,PurchaseOrderModuleId,BillOrderModuleId,VendorReturnModuleId,VendorCreditModuleId,BillPaymentModuleId]
        },
        {
            id: WorkflowModelsNS.WorkflowEmailAssignedType.Location,
            name: 'Locations',
            label: 'Location',
            activeModules: [LocationModuleId]
        },
        {
            id: WorkflowModelsNS.WorkflowEmailAssignedType.Contact,
            name: 'Contacts',
            label: 'Contacts',
            activeModules: [AccountModuleId,LeadModuleId]
        }
    ];
    assignedTypes = this.allAssignedTypes;
    contactAssignTypes: any[] = [
        { id: 3, name: 'Work Email', parent: 1 },
        { id: 4, name: 'Home Email', parent: 1 },
        { id: 5, name: 'CE1', parent: 1 },
        { id: 6, name: 'CE2', parent: 1 }
    ];
    contactAssignTypesGroup: any[] = [];

    activeUsers: any[] = [];
    activeUserTree: any[] = [];
    modules: any[] = [
        {
            id: 1,
            name: 'Lead'
        },
        {
            id: 2,
            name: 'Account'
        }
    ];
    selectedType: NotificationEmailTemplateFields = null;
    emailTemplateList: NotificaitonEmailTemplateModel[] = [];
    smtpList: any[] = [];
    whatsAppBusinessAccounts: any[] = [];
    notificationTypeEnum = WorkflowModelsNS.WorkflowNotificationTypeEnum;

    //Workflow details form
    emailDetailsForm: FormGroup = new FormGroup({});
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    notificationBody: string = "";
    selectedInsertField: string = "";
    subjectCursorPosition = {
        start: 0,
        end: 0
    };

    removedFields: string[] = [];

    //Include Saved Search
    displaySavedSearchRule: boolean = false;
    addedSavedSearch: WorkflowModelsNS.WorkflowEmailSavedSearchs[] = [];
    selectedSavedSearchIndex: number = -1;
    selectedSavedSearch: WorkflowModelsNS.WorkflowEmailSavedSearchs;
    detailsAttachedFor: number[] = [InvoiceOrderModuleId,SOModuleId,EstimateOrderModuleId,PurchaseOrderModuleId,BillOrderModuleId,VendorReturnModuleId,BillPaymentModuleId];

    //Fields List
    fieldTypes: SavedSearchNS.IField[] = [];
    fieldTypesByGroup: any[] = [];
    availableFields: SavedSearchNS.IField[] = [];
    currentColList: any[] = [];
    hiddenFields: string[] = ['contactCreatedBy','contactCreatedDate','contactUpdatedBy','contactUpdatedDate','contactId','mainCustomerId'];
    hiddenFieldsForProduct: string[] = ['packageBarcode','serialNoBarcode','lotNumber','revisionNumber','expirationDate'];

    visibleEmailGenerationScenario: boolean = false;

    editorModules = {};
    defaultAIImage = `${environment.assestsBasePath}layout/images/ai-icon.png`;

    constructor(
        private formBuilder: FormBuilder,
        public app: AppMainComponent,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private workflowService: WorkflowService,
        private configurationService: ConfigurationService,
        private emailTemplateService: EmailTemplateService,
        private documentsService: MyDocumentsService,
        private documentViewerService: DocumentViewerService,
        private sharedTemplateService: SharedTemplateService,
        private purchaseService: PurchasesService,
        private domManipulationService: DomManipulationService,
        private chatFacade: ChatFacade,
        private renderer: Renderer2
    ) { }

    ngOnInit(): void {
        this.initEditorModules();
        this.initEmailForm();
        this.loadDropdownValues();
    }

    ngOnChanges(changes: SimpleChanges): void {

        if(changes['notificationType'] && changes['notificationType']?.currentValue){
            this.notificationType = changes['notificationType'].currentValue;
            this.updatSubjectValidators();
            this.updatFromValidators();
            if(this.notificationType==WorkflowModelsNS.WorkflowNotificationTypeEnum.WHATSAPP){
                this.emailAddEditHeader = 'Add Whatsapp Alert';
                this.emailTypeName = 'Whatsapp Alert';
            }else{
                this.emailAddEditHeader = 'Add Email';
                this.emailTypeName = 'Email';
            }
        }

        if(changes['selectedActionEmail'] && changes['selectedActionEmail']?.currentValue){
            this.selectedActionEmail = changes['selectedActionEmail']?.currentValue;
        }

        if (changes['selectedParentModule'] && changes['selectedParentModule']?.currentValue) {
            this.selectedParentModule = changes['selectedParentModule']?.currentValue;
        }

        if(changes['parentTemplates'] && changes['parentTemplates']?.currentValue){
            this.parentTemplates = changes['parentTemplates']?.currentValue;
        }

        if (changes['selectedActionModule'] && changes['selectedActionModule']?.currentValue) {
            this.selectedActionModule = changes['selectedActionModule']?.currentValue;
            this.selectModuleAndChannel();
        }

        if (changes['selectedParentTemplate'] && changes['selectedParentTemplate']?.currentValue) {
            this.selectedParentTemplate = changes['selectedParentTemplate']?.currentValue;
            this.selectModuleAndChannel();
        }

        if(changes['workflowType'] && changes['workflowType']?.currentValue){
            this.workflowType = changes['workflowType'].currentValue;
        }

        if (changes['displayAddEmail'] && changes['displayAddEmail']?.currentValue) {
            this.displayAddEmail = changes['displayAddEmail']?.currentValue;
            this.loadInitialData();
        }
    }

    setContactsEmailGroup(){
        // Step 1: Create a map to group items by their parent ID
        const groupedMap = new Map<number, any[]>();

        // Step 2: Populate the map with child items
        for (const item of this.contactAssignTypes) {
            if (item.parent !== null) {
                if (!groupedMap.has(item.parent)) {
                    groupedMap.set(item.parent, []);
                }
                groupedMap.get(item.parent)?.push(item);
            }
        }

        // Step 3: Create the final grouped array
        this.contactAssignTypesGroup = this.contactAssignTypes
            .filter(item => item.parent === null)
            .map(item => ({
                label: item.label,
                items: groupedMap.get(item.id) || []
            }));
    }

    selectModuleAndChannel(){
        if(this.selectedActionModule?.objectId && this.selectedActionModule?.objectId!=this.selectedParentModule?.objectId){
            this.selectedModule = ParseHelper.DeepCopy(this.selectedActionModule);
            this.selectedChannelId = this.selectedActionModule.channelId;
        }else{
            this.selectedModule = ParseHelper.DeepCopy(this.selectedParentModule);
            this.selectedChannelId = this.selectedParentTemplate?.channelId||0;
        }
    }

    loadInitialData(){
        if(this.selectedParentModule?.objectId){
            this.assignedTypes = this.allAssignedTypes.filter(list=> list.activeModules.includes(this.selectedModule?.objectId));
        }

        this.setEditorDefaultType();
        this.getAllEmailTemplates();

        if([InvoiceOrderModuleId,EstimateOrderModuleId,SOModuleId,ProductModuleId].includes(this.selectedModule?.objectId)){
            this.getTemplateFields(this.selectedModule?.objectId,this.selectedModule?.objectId);
        }
        else if([PurchaseOrderModuleId,BillOrderModuleId,VendorReturnModuleId,VendorCreditModuleId,BillPaymentModuleId].includes(this.selectedModule?.objectId)){
            this.getAssociatedTemplateFields(this.selectedParentModule.objectId,333);
        }
        else{
            this.getSavedSearchTemplateFields();
        }
        // if([AccountModuleId,LeadModuleId,OpportunityModuleId].includes(this.selectedModule?.objectId)){
        //     this.getLeadAccountTemplateFields();
        // }else if([VendorModuleId].includes(this.selectedModule?.objectId)){
        //     this.loadVendorConfiguration();
        // }else if([LocationModuleId].includes(this.selectedModule?.objectId)){
        //     this.getSavedSearchTemplateFields();
        // }else{
        //     this.getTemplateFields();
        // }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    dialogClose(){
        const subCtrl = this.emailDetailsForm.get('subject');
        const desCtrl = this.emailDetailsForm.get('body');
        subCtrl.enable();
        desCtrl.enable();

        this.initEmailForm();
        this.displayAddEmail = false;
        this.dialogClosed.emit(true);
    }

    //#region Available Fields

    loadVendorConfiguration(){
        this.appMainService.isShowSpinner('vendorFields');
        this.purchaseService.getPOConfigurations('Purchase').subscribe(config => {
            this.appMainService.isHideSpinner('vendorFields');
            //Product Templates
            const vendorTemplates = config.filter(config => (config.name == 'Purchase Template'))[0];
            const templates = JSON.parse(vendorTemplates.configurationDetails[0].configJSONValue);
            const vendorTemplate = templates.find((t) => t.templateName == 'Vendors_template');
            this.generateVendorAvailableFields(vendorTemplate);
        }, (error)=>{
            this.appMainService.isHideSpinner('vendorFields');
        });
    }

    getTemplateFields(parentObjectId: number, moduleId: number){
        this.appMainService.isShowSpinner('getFieldListByTemplate');
        this.configurationService.getTemplateDetails(parentObjectId, moduleId, this.selectedChannelId, true).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((resp: SavedSearchNS.IField[]) => {
            this.appMainService.isHideSpinner('getFieldListByTemplate');
            //Prepar Field Object
            this.generateAvailableFields(resp);
        },
        error => {
            this.appMainService.isHideSpinner('getFieldListByTemplate');
        });
    }

    getAssociatedTemplateFields(parentObjectId: number, assosModuleId: number){
        this.appMainService.isShowSpinner('getColumnSettings');
        this.sharedTemplateService.getTemplatesSectionsFieldsForSavedSearch(parentObjectId, assosModuleId, this.selectedChannelId).subscribe(
        {
            next: (response) => {
                this.currentColList = response || [];
                this.currentColList
                .map((section, i)=>{
                    section.customFields.map((customFields, i)=>{
                        const formControlDetails: any = ParseHelper.DeepCopy(customFields.formControl);
                        customFields = {
                            ...customFields,
                            formControl: formControlDetails?.type,
                            formControlDetails: formControlDetails,
                            isCustom: true
                        }

                        section.customFields[i] = customFields;
                    })
                    section.customFields = section.customFields.filter((fields) => fields.enableSavedSearchColumnSetting);
                    section.fields = section.fields.filter((fields) => fields.enableSavedSearchColumnSetting);
                    section.fields.map((fields, i)=>{
                        if(fields.childFields?.length>0){
                        fields.childFields = fields.childFields.filter((childField) => childField.enableSavedSearchColumnSetting);
                        }
                    })                   
                });
                this.generateLAAvailableFields('labelName');
                this.appMainService.isHideSpinner('getColumnSettings');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getColumnSettings');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                });
            },
            complete: () => {

            },
        });
    }

    getLeadAccountTemplateFields(){
        this.appMainService.isShowSpinner('getColumnSettings');
        this.sharedTemplateService.getTemplateSectionsForFormBuild(this.selectedModule?.objectId, this.selectedChannelId).subscribe(
        {
            next: (response) => {
                this.currentColList = response || [];
                this.currentColList.map((fields, i)=>[
                    fields.customFields.map((customFields, i)=>{
                        const formControlDetails: any = ParseHelper.DeepCopy(customFields.formControl);
                        customFields = {
                            ...customFields,
                            formControl: formControlDetails?.type,
                            formControlDetails: formControlDetails,
                            isCustom: true
                        }

                        fields.customFields[i] = customFields;
                    })
                ]);
                this.generateLAAvailableFields();
                this.appMainService.isHideSpinner('getColumnSettings');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getColumnSettings');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                });
            },
            complete: () => {

            },
        });
    }

    getSavedSearchTemplateFields(){
        this.appMainService.isShowSpinner('getSavedSearchColumnSettings');
        this.sharedTemplateService.getModuleColumnSettingForSavedSearch(this.selectedParentModule?.objectId, this.selectedChannelId).subscribe(
        {
            next: (response) => {
                this.currentColList = response?.listViewSections || [];
                this.currentColList = this.currentColList.filter(s=> [this.selectedParentModule?.objectId,ContactModuleId].includes(s?.moduleId) && !['Last Transaction Activities'].includes(s?.name));
                this.generateLAAvailableFields('systemGeneratedName');
                this.appMainService.isHideSpinner('getSavedSearchColumnSettings');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getSavedSearchColumnSettings');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                });
            },
            complete: () => {

            },
        });
    }

    generateVendorAvailableFields(vendorTemplate: any){
        let updateFields: any[] = WF_VENDOR_UPDATE_FIELDS;
        this.currentColList = [];
        updateFields.map((section, sectionInex)=>{
            const sectionData = {
                name: section.label,
                fields: [],
                customFields: []
            }

            if(vendorTemplate[section.sectionCode]?.length>0){
                vendorTemplate[section.sectionCode].map(checkfield=>{
                    if(checkfield?.isChecked){
                        sectionData.fields.push({
                            ...checkfield,
                            field: checkfield.code,
                            isCustom: checkfield.custom,
                            labelName: checkfield?.labelname||checkfield.name,
                            formControl: getFormControlNameById(checkfield?.formControlId)
                        })
                    }
                });

                this.currentColList.push(sectionData);
            }
        });

        this.generateLAAvailableFields();
    }

    generateLAAvailableFields(nameField: string = 'name'){
        this.fieldTypes = [];
        let fieldTypesByGroup = [];

        this.currentColList.map(sectionDetails=>{
            const group: any = {
                label: sectionDetails.name,
                value: "",
                items: []
            }
            sectionDetails.fields.map(field=>{
                field.field = field?.field||field?.columnName||field?.name;
                field.formControl = field?.formControl||field?.formControlType;
                if(field?.childFields?.length>0){
                    const childGroup: any[] = [];
                    field.childFields.map(childField=>{
                        childField.field = childField?.field||childField?.columnName;
                        childField.formControl = childField?.formControl||childField?.formControlType;
                        const fieldDetails = this.setFieldDetails(childField,nameField);
                        if(fieldDetails) childGroup.push({
                            ...fieldDetails,
                            label: fieldDetails.name,
                            childItem: true
                        })
                    })

                    if(childGroup.length>0){
                        const {childFields, ...parentFieldData} = field;
                        const parentField = {
                            ...this.setFieldDetails(parentFieldData,nameField),
                            label: field.name,
                            childGroup: true
                        };

                        group.items = [...group.items,...[parentField],...childGroup]
                    }
                }else{
                    const fieldDetails = this.setFieldDetails(field,nameField);
                    if(fieldDetails) group.items.push({
                        ...fieldDetails,
                        label: fieldDetails.name
                    })
                }
            });

            sectionDetails?.customFields?.map(field=>{
                field = {...field, isCustom: true};
                const fieldDetails = this.setFieldDetails(field,nameField);
                if(fieldDetails) group.items.push({
                    ...fieldDetails,
                    label: fieldDetails.name
                })
            });

            fieldTypesByGroup.push(group);
        });
        this.fieldTypesByGroup = ParseHelper.DeepCopy(fieldTypesByGroup);
        this.availableFields = ParseHelper.DeepCopy(this.fieldTypes);

        this.setAvailableFields();
    }

    generateAvailableFields(fieldList: SavedSearchNS.IField[]){
        let temFilters: SavedSearchNS.IField[] = [];
        //process fields
        fieldList?.map(x => {
            // if(!x.operators){console.log(x)}
            x.operatorsDD = x.operators?.length>0 ? x.operators.map((o, i) => ({ id: i + 1, name: o })) : [];
            //******if field == null, email,phone, social
            if (x.fieldTypes) {
                let fieldTypesList = x.fieldTypes?.fields?.map(f => {
                    f.fieldDataType = x.fieldDataType;
                    f.operators = x.operators||[];
                    f.field = f.field;
                    f.valueDataType = x.fieldDataType;
                    f.isSelectableField = true;
                    return f;
                });
                if (fieldTypesList) {
                    temFilters.push(...fieldTypesList);
                }
            }
            //Set Value DataType for UI implementation
            setSavedSearchValueDateType(x);
            if (x.field) {
                temFilters.push(x);
            }
        });
        temFilters = temFilters?.map(x => {
            x.operatorsDD = x.operators?.length>0 ? x.operators.map((o, i) => ({ id: i + 1, name: o })) : [];
            return x;
        });

        this.availableFields = temFilters.filter(avalableActiveField => !this.hiddenFieldsForProduct.includes(avalableActiveField.field))
        const group: any = {
            label: this.selectedModule.name,
            value: "",
            items: []
        }

        this.availableFields.map(field=>{
            group.items.push({
                ...field,
                label: field.labelname
            })
        });
        this.fieldTypesByGroup = ParseHelper.DeepCopy([group]);
        this.setAvailableFields();
    }

    setFieldDetails(fieldDetails: LeadAccountUpdateFieldsModel, nameField: string = 'name'){
        let field = null;
        if(fieldDetails?.field && !this.hiddenFields.includes(fieldDetails.field) && ![FormControlList.FileUpload,FormControlList.Picture].includes(fieldDetails.formControl)){
            // fieldDetails.field = (fieldDetails.field == 'tags') ? 'tagsCsv' : fieldDetails.field;
            field = {
                id: fieldDetails.id,
                labelname: fieldDetails?.labelName||fieldDetails?.name,
                name: this.getFormatedName(fieldDetails, nameField),
                code: fieldDetails.field,
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                isDuplicate: true,
                isGlobalSearch: true,
                width: "",
                movable: false,
                showForDrag: false,
                templateId: this.selectedChannelId||0,
                sectionId: 0,
                custom: !!fieldDetails?.isCustom,
                formControlId: FormControlListIds[fieldDetails.formControl],
                formControl: fieldDetails.formControl,
                pickListValues: fieldDetails?.formControlDetails?.pickListValues||[],
                field: fieldDetails.field,
                mapObject: fieldDetails?.mapObject,
                isColumnSetting: true,
                value: "",
                displayOrder: fieldDetails?.displayOrder,
                fieldTypes: null,
                fieldDataType: "String",
                valueDataType: "String",
                operators: [],
                operatorsDD: [],
                enableSavedSearchColumnSetting:fieldDetails?.enableSavedSearchColumnSetting,
                enableSavedSearchQuery: fieldDetails?.enableSavedSearchQuery,
            }
            this.fieldTypes.push(field);
        }

        return field;
    }

    getFormatedName(fieldDetails: LeadAccountUpdateFieldsModel, nameField: string = 'name'){
        let name = fieldDetails[nameField];

        if((['website','twitter','facebook','linkedin','instagram'].includes(fieldDetails?.field) && this.selectedModule?.objectId==LeadModuleId) || fieldDetails.mapObject=='leadSocial'){
            name = `Lead ${name}`
        }

        if((['website','twitter','facebook','linkedin','instagram'].includes(fieldDetails?.field) && this.selectedModule?.objectId==AccountModuleId) || fieldDetails.mapObject=='accountSocial'){
            name = `Account ${name}`
        }

        return name;
    }

    setAvailableFields(){
        if(this.fieldTypesByGroup?.length>0){
            this.fieldTypesByGroup.map(group=>{
                if(group?.items?.length>0){
                    const availableItems = group.items.filter(fieldDetails=> fieldDetails?.field && fieldDetails?.mapObject!='opportunityProduct' && !this.removedFields.includes(fieldDetails.field) && ![FormControlList.FileUpload,FormControlList.Picture].includes(fieldDetails.formControl));
                    group.items = availableItems;
                }
            })
        }


        if([LeadModuleId,AccountModuleId].includes(this.selectedModule?.objectId)){
            this.availableFields = this.availableFields?.length>0? this.availableFields.filter(x=> !this.removedFields.includes(x.field)) : [];
        }

        this.fieldTypes = [...this.availableFields];
        this.initEmailForm();
        if(this.selectedActionEmail){
            this.setEmailEditData(this.selectedActionEmail)
        }
    }

    //#endregion Available Fields End

    //Email Form
    initEmailForm(){
        if(this.notificationType==WorkflowModelsNS.WorkflowNotificationTypeEnum.WHATSAPP){
            this.emailAddEditHeader = 'Add Whatsapp Alert';
            this.emailTypeName = 'Whatsapp Alert';
        }else{
            this.emailAddEditHeader = 'Add Email';
            this.emailTypeName = 'Email';
        }

        this.detailsFormErrors = {};
        this.isUnsavedData = false;
        this.attachments = [];
        this.addedSavedSearch = [];
        this.addedFieldTags = [];
        this.emailDetailsForm = this.formBuilder.group({
            id: [0],
            name: ["Workflow Trigger Email", [Validators.required]],
            from: [null],
            whatsappFrom: [null],
            fromUserId: [this.app?.userId||null, [Validators.required]],
            subject: [{disabled: this.viewOnly, value: ""}],
            body: [{disabled: this.viewOnly, value: ""}, [Validators.required, fieldTagsValidator(this.fieldTypes)]],
            emailTemplate: [null],
            isDetailAttached: [false],
            selectedModule: [null],
            assignedType: [this.assignedTypes[0], [Validators.required]],
            assignedUsers: [null, [Validators.required]],
            assignedUsersCc: [null],
            assignedUsersBcc: [null]

        });

        if(this.viewOnly){
            this.emailDetailsForm.disable();
        }

        this.notificationBody = "";
        this.formErrorHandler.handleErrors(this.emailDetailsForm, this.detailsFormErrors, {
            name: {
                required: "Enter Notification Name",
            },
            from: {
                required: "Select any user",
            },
            whatsappFrom: {
                required: "Select Whatsapp Business Contact",
            },
            fromUserId: {
                required: `Select from`,
            },
            subject: {
                required: `Enter notification subject`,
                invalidFieldTags: `Subject have invalid field tags:`
            },
            body: {
                required: `Enter notification body`,
                invalidFieldTags: `Body have invalid field tags:`,
                fieldTagsRequired: 'For Time Based Workflow fields are required, Please insert any fields'
            },
            assignedUsers: {
                required: "Select any users",
            }
        });

        this.emailDetailsForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(e => this.isUnsavedData = true);

        this.emailDetailsForm.get('body').valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(value=>{
            this.notificationBody = value;
            this.updatedAddedTags();
        })

        this.emailDetailsForm.get('subject').valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(value=>{
            this.updatedAddedTags();
        });

        const userList = this.getFlatArrayFormChilren(this.activeUserTree)||[];
        const selectedUser = userList.find(user=>user.id==this.app.userId);

        if(selectedUser){
            this.emailDetailsForm.patchValue({
                assignedUsers: [selectedUser]
            })
        }

        const defaultSMTP = this.smtpList.find(smtp=> smtp?.isDefault);

        if(!this.emailDetailsForm.getRawValue().from && defaultSMTP){
            this.emailDetailsForm.patchValue({
                from: defaultSMTP
            })
        }

        const defaultWB = this.whatsAppBusinessAccounts.find(wb=> wb?.isDefault);

        if(!this.emailDetailsForm.getRawValue().from && defaultWB){
            this.emailDetailsForm.patchValue({
                whatsappFrom: defaultWB
            })
        }
    }

    updateBodyValidators(){
        const bodyCtrl = this.emailDetailsForm.get('body');

        if(bodyCtrl){
            bodyCtrl.setValidators([fieldTagsValidator(this.fieldTypes)]);
            bodyCtrl.updateValueAndValidity();
        }
    }

    updatSubjectValidators(){
        const subjectCtrl = this.emailDetailsForm.get('subject');

        if(subjectCtrl){
            const validators = this.notificationType==WorkflowModelsNS.WorkflowNotificationTypeEnum.WHATSAPP ? [fieldTagsValidator(this.fieldTypes)] : [Validators.required,fieldTagsValidator(this.fieldTypes)];
            subjectCtrl.setValidators(validators);
            subjectCtrl.updateValueAndValidity();
        }
    }

    updatFromValidators(){
        const fromCtrl = this.emailDetailsForm.get('whatsappFrom');

        if(fromCtrl){
            const validators = this.notificationType==WorkflowModelsNS.WorkflowNotificationTypeEnum.WHATSAPP ? [Validators.required] : [];
            fromCtrl.setValidators(validators);
            fromCtrl.updateValueAndValidity();
        }
    }

    updatedAddedTags(){
        this.addedFieldTags = [];
        const value = this.emailDetailsForm.getRawValue().body + this.emailDetailsForm.getRawValue().subject;
        if(value){
            const addedTags: string[] = value.match(customFieldTagRegex)||[];

            addedTags.map(labelName=>{
                const exist = this.fieldTypes.find(field=>field.name.trim()==labelName.trim());

                if(exist){
                    if(!this.addedFieldTags.includes(exist.name))
                        this.addedFieldTags.push(exist.name);
                }
            })
        }
    }

    setEmailEditData(selectedActionEmail: WorkflowModelsNS.WorkflowAddEditActionEmail){
        if(this.notificationType==WorkflowModelsNS.WorkflowNotificationTypeEnum.WHATSAPP){
            this.emailAddEditHeader = this.viewOnly ? 'View Whatsapp Alert' : 'Edit Whatsapp Alert';
        }else{
            this.emailAddEditHeader = this.viewOnly ? 'View Email' : 'Edit Email';
        }

        const assignType = this.selectedActionEmail.workflowActionEmailList
        .find(user => user?.statusId == Status.Active && user.emailNotificationType === this.workflowEmailRecipientType.TO);
        const assignedType = this.assignedTypes.find(c=>c.id==assignType?.assignedType)||this.assignedTypes[0];
        const templateDetails: NotificaitonEmailTemplateModel = this.emailTemplateList.find(template=> template.id == selectedActionEmail.emailTemplateId)||null;

        const assignedIds: any[] = [];
        const ccAssignedIds: any[] = [];
        const bccAssignedIds: any[] = [];
        let assignedList = this.getFlatArrayFormChilren(this.activeUserTree)||[];
        let assignedListForCcBcc = this.getFlatArrayFormChilren(this.activeUserTree)||[];

        if([WorkflowModelsNS.WorkflowEmailAssignedType.Contact].includes(assignedType?.id)){
            assignedList = this.contactAssignTypes;
        }

        this.selectedActionEmail.workflowActionEmailList?.filter(userDetails=> userDetails.statusId==Status.Active).map(userDetails=>{
            const selected = assignedList.find(user=>user?.id==userDetails.assignedId  && userDetails.emailNotificationType==this.workflowEmailRecipientType.TO);
            if(selected) assignedIds.push(selected);
        });
            //patch cc and bcc
        this.selectedActionEmail.workflowActionEmailList?.filter(userDetails=> userDetails.statusId==Status.Active).map(userDetails=>{
            const selectedCcAssignedIds = assignedListForCcBcc.find(user=>user?.id == userDetails.assignedId && userDetails.emailNotificationType === this.workflowEmailRecipientType.CC);
            if(selectedCcAssignedIds) ccAssignedIds.push(selectedCcAssignedIds);
        });

        this.selectedActionEmail.workflowActionEmailList?.filter(userDetails=> userDetails.statusId==Status.Active).map(userDetails=>{
            const selectedBccAssignedIds = assignedListForCcBcc.find(user=>user?.id==userDetails.assignedId  && userDetails.emailNotificationType === this.workflowEmailRecipientType.BCC);
            if(selectedBccAssignedIds) bccAssignedIds.push(selectedBccAssignedIds);
        });

        let bodyText: any = selectedActionEmail.body||"";
        bodyText = this.domManipulationService.replaceDivWithP(bodyText);
        const defaultSMTP = this.smtpList.find(smtp=> smtp?.isDefault);
        const addedSMTP = defaultSMTP ? defaultSMTP : this.smtpList.find(smtp=>smtp.id==selectedActionEmail.from);

        this.emailDetailsForm.patchValue({
            id: selectedActionEmail.id,
            name: selectedActionEmail.name||"Workflow Trigger Email",
            subject: selectedActionEmail.subject||"",
            body: bodyText,
            isDetailAttached: selectedActionEmail.isDetailAttached,
            from: addedSMTP||null,
            whatsappFrom: this.whatsAppBusinessAccounts.find(wb=>wb.id==selectedActionEmail.from)||null,
            fromUserId: selectedActionEmail?.fromUserId||this.app?.userId,
            assignedType: assignedType,
            assignedUsers: [WorkflowModelsNS.WorkflowEmailAssignedType.User,WorkflowModelsNS.WorkflowEmailAssignedType.Contact].includes(assignedType?.id) ? assignedIds||null : null,
            assignedUsersCc: ccAssignedIds?.length > 0 ? ccAssignedIds : null,
            assignedUsersBcc: bccAssignedIds?.length > 0 ? bccAssignedIds : null,
            emailTemplate: templateDetails||null
        });

        this.attachments = selectedActionEmail.workflowEmailAttachments?.length>0  ? selectedActionEmail.workflowEmailAttachments.filter(attachment=> attachment.statusId==Status.Active) : [];
        this.addedSavedSearch = selectedActionEmail.workflowEmailSavedSearchs?.length>0 ? selectedActionEmail.workflowEmailSavedSearchs.filter(savedSearch => savedSearch.statusId==Status.Active) : [];
        this.notificationBody = bodyText;
        this.updatedAddedTags();
        if(this.editor && this.notificationBody){
            this.loadContentInEditor(this.notificationBody);
        }
        // const subCtrl = this.emailDetailsForm.get('subject');
        // const desCtrl = this.emailDetailsForm.get('body');

        // if(this.viewOnly){
        //     subCtrl.disable();
        //     desCtrl.disable();
        // }else{
        //     subCtrl.enable();
        //     desCtrl.enable();
        // }

        this.selectAssignType();
    }

    saveEmail(){
        this.updatedAddedTags();
        this.updatSubjectValidators();
        if (this.emailDetailsForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }

        let from = this.emailDetailsForm.getRawValue().from?.id||0;
        let fromUserId = this.emailDetailsForm.getRawValue().fromUserId;

        if(this.notificationType==this.notificationTypeEnum.WHATSAPP){
            from = this.emailDetailsForm.getRawValue().whatsappFrom?.id||0;
            fromUserId = 0;
        }

        //replace newline
        let messageData: any = this.notificationBody;
        messageData = this.domManipulationService.replacePWithDiv(messageData);
        messageData = addInlineStyles(messageData);
        this.notificationBody = messageData;

        const emailData: WorkflowModelsNS.WorkflowAddEditActionEmail = {
            id: this.selectedActionEmail?.id||0,
            statusId: this.selectedActionEmail?.statusId||1,
            workflowActionId: this.selectedActionEmail?.workflowActionId||0,
            objectId: this.selectedModule.objectId,
            objectName: this.selectedModule.name,
            name: this.emailDetailsForm.getRawValue().name||"",
            from: from,
            fromUserId: fromUserId,
            subject: this.emailDetailsForm.getRawValue().subject,
            body: this.notificationBody||"",
            isDetailAttached: this.emailDetailsForm.getRawValue().isDetailAttached,
            notificationType: this.notificationType||WorkflowModelsNS.WorkflowNotificationTypeEnum.EMAIL,
            emailTemplateId: this.emailDetailsForm.getRawValue().emailTemplate?.id||0,
            workflowEmailTemplateFields: [],
            workflowActionEmailList: [],
            workflowEmailAttachments: this.attachments||[],
            workflowEmailSavedSearchs: this.emailDetailsForm.getRawValue().assignedType?.id==1 ? this.addedSavedSearch||[] : []
        }

        emailData.body = addInlineStyles(emailData.body);

        if([WorkflowModelsNS.WorkflowEmailAssignedType.User,WorkflowModelsNS.WorkflowEmailAssignedType.Contact].includes(this.emailDetailsForm.getRawValue().assignedType?.id)){
            this.emailDetailsForm.value?.assignedUsers?.map(userDetails=> {

                let id = 0;

                if(this.selectedActionEmail){
                    const addedUser = this.selectedActionEmail.workflowActionEmailList.find(user=>user.assignedId==userDetails.id);
                    id = addedUser ? addedUser.id : 0;
                }
                emailData.workflowActionEmailList.push({
                    id: id,
                    workflowActionEmailId: this.selectedActionEmail?.id||0,
                    emailNotificationType: this.workflowEmailRecipientType.TO,
                    assignedType: this.emailDetailsForm.getRawValue().assignedType.id,
                    assignedId: userDetails.id,
                    statusId: 1

                })
            });


        }else{

            let id = 0;

            if(this.selectedActionEmail){
                const addedUser = this.selectedActionEmail.workflowActionEmailList.find(user=>user.assignedType==this.emailDetailsForm.getRawValue().assignedType.id);
                id = addedUser ? addedUser.id : 0;
            }

            emailData.workflowActionEmailList.push({
                id: id,
                workflowActionEmailId: this.selectedActionEmail?.id||0,
                emailNotificationType: this.workflowEmailRecipientType.TO,
                assignedType: this.emailDetailsForm.getRawValue().assignedType.id,
                assignedId: 0,
                statusId: 1
            })

        }

        // Add "CC" Users
        if (this.emailDetailsForm.value?.assignedUsersCc) {
            this.emailDetailsForm.value?.assignedUsersCc?.map(userDetails => {
                let id = 0;
                if (this.selectedActionEmail) {
                    const addedUser = this.selectedActionEmail.workflowActionEmailList.find(user => user.assignedId == userDetails.id && user.emailNotificationType === this.workflowEmailRecipientType.CC);
                    id = addedUser ? addedUser.id : 0;
                }
                emailData.workflowActionEmailList.push({
                    id: id,
                    workflowActionEmailId: this.selectedActionEmail?.id || 0,
                    emailNotificationType: this.workflowEmailRecipientType.CC,
                    assignedType:  WorkflowModelsNS.WorkflowEmailAssignedType.User,
                    assignedId: userDetails.id,
                    statusId: 1
                });
            });
        }

        // Add "Bcc" Users
        if (this.emailDetailsForm.value?.assignedUsersBcc) {
            this.emailDetailsForm.value?.assignedUsersBcc?.map(userDetails => {
                let id = 0;
                if (this.selectedActionEmail) {
                    const addedUser = this.selectedActionEmail.workflowActionEmailList.find(user => user.assignedId == userDetails.id && user.emailNotificationType === this.workflowEmailRecipientType.BCC);
                    id = addedUser ? addedUser.id : 0;
                }
                emailData.workflowActionEmailList.push({
                    id: id,
                    workflowActionEmailId: this.selectedActionEmail?.id || 0,
                    emailNotificationType: this.workflowEmailRecipientType.BCC,
                    assignedType: WorkflowModelsNS.WorkflowEmailAssignedType.User,
                    assignedId: userDetails.id,
                    statusId: 1
                });
            });
        }

        //Set removed assigned user
        if(this.selectedActionEmail){
            this.selectedActionEmail.workflowActionEmailList.map(assignedUser=>{
                const exist = emailData.workflowActionEmailList.find(details=>details.assignedId==assignedUser.assignedId);
                if(!exist){
                    emailData.workflowActionEmailList.push({
                        ...assignedUser,
                        statusId: 3
                    })
                }
            })

        }

        this.addedFieldTags.map(labelName=>{
            const exist = this.fieldTypes.find(field=>field.name==labelName);
            if(exist){
                let id = 0;

                if(this.selectedActionEmail){
                    const addedField = this.selectedActionEmail.workflowEmailTemplateFields.find(field=>field.fieldName==exist.field);
                    id = addedField ? addedField.id : 0;
                }

                emailData.workflowEmailTemplateFields.push({
                    id: id,
                    workflowActionEmailId: this.selectedActionEmail?.id||0,
                    fieldName: exist.field,
                    columnSettingId: exist.id,
                    displayOrder: exist?.displayOrder||0,
                    templateFieldName: exist.name.trim(),
                    statusId: 1,
                    isCustom: exist.custom
                })
            }
        })

        //Set removed fields
        if(this.selectedActionEmail){
            this.selectedActionEmail.workflowEmailTemplateFields.map(previousField=>{
                const exist = emailData.workflowEmailTemplateFields.find(field=>field.fieldName==previousField.fieldName);
                if(!exist){
                    emailData.workflowEmailTemplateFields.push({
                        ...previousField,
                        statusId: 3
                    })
                }
            })
        }

        this.emailSaved.emit(emailData);
        this.dialogClose();
    }

    uploadAttachments(files: File[]) {
        this.appMainService.isShowSpinner('upload');
        if (typeof Worker !== undefined) {
            for (let file of files) {
                let errors = validateFiles(file, 4, this.allowedExtensions);
                if (errors.length > 0) {
                    for (let error of errors) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.fileName + ": " + error.error });
                    }
                    this.appMainService.isHideSpinner('upload');
                } else {
                    uploadFiles(file, ({ name, content, size, extension }) => {

                        let mime_type = this.mimeTypes.find(el => el.extension === extension.toLowerCase());

                        let attachment = {
                            id: 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            updatedBy: 0,
                            createdDate: new Date(),
                            updatedDate: new Date(),
                            name: name,
                            guidName: "",
                            content: content,
                            extension: extension,
                            sizeInBytes: size,
                            mediaType: mime_type?.value||"",
                            description: "",
                            statusId: Status.Active,
                            isValid: true,
                            moduleName: this.selectedModule?.name,
                            isModuleFolder: true
                        };

                        this.attachments.push({
                            workflowActionEmailId: this.emailDetailsForm.getRawValue().id,
                            id: 0,
                            fileName: name,
                            displayFileName: name,
                            filePath: name,
                            mediaType: mime_type?.value||"",
                            fileSize: size,
                            statusId: Status.Active,
                            attachment: attachment
                        });
                        this.appMainService.isHideSpinner('upload');
                    });
                }
            }
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
        }
    }

    removeAttachment(attachment: any, index: number){
        if(attachment?.id>0){
            attachment.statusId = Status.Deleted;
        }else{
            this.attachments.splice(index,1);
        }
    }

    selectAssignType(updateValue: boolean = false){
        const assignType = this.emailDetailsForm.getRawValue().assignedType;

        const assignedUsersCtrl = this.emailDetailsForm.get('assignedUsers');

        if(assignedUsersCtrl){

            if([WorkflowModelsNS.WorkflowEmailAssignedType.User,WorkflowModelsNS.WorkflowEmailAssignedType.Contact].includes(assignType?.id)){
                assignedUsersCtrl.setValidators([Validators.required]);
            }else{
                assignedUsersCtrl.setValidators([]);
                switch(this.notificationType){
                    case this.notificationTypeEnum.WHATSAPP:
                        this.defaultEmail = assignType.label + ` Primary Contact`;
                        break;
                    default:
                        this.defaultEmail = assignType.label + ` Email`;
                        break;
                }

            }

            assignedUsersCtrl.updateValueAndValidity();
        }

        if(updateValue){
            const userList = this.getFlatArrayFormChilren(this.activeUserTree)||[];
            const selectedUser = userList.find(user=>user.id==this.app.userId);

            if(selectedUser && WorkflowModelsNS.WorkflowEmailAssignedType.User==assignType?.id){
                this.emailDetailsForm.patchValue({
                    assignedUsers: [selectedUser]
                })
            }

            if(WorkflowModelsNS.WorkflowEmailAssignedType.Contact==assignType?.id){
                this.emailDetailsForm.patchValue({
                    assignedUsers: [this.contactAssignTypes[0]]
                })
            }
        }

        const detailAttachedControl = this.emailDetailsForm.get('isDetailAttached');
        if(detailAttachedControl && this.detailsAttachedFor.includes(this.selectedModule?.objectId)){
            if(assignType?.id == 3){
                this.emailDetailsForm.patchValue({
                    isDetailAttached: true
                });
                detailAttachedControl.disable();
                detailAttachedControl.setValidators([Validators.required]);
            }else{
                detailAttachedControl.enable();
                detailAttachedControl.setValidators([]);
            }
            detailAttachedControl.updateValueAndValidity();
        }
    }

    selectEmailTemplate($event: any){
        if(this.emailDetailsForm.getRawValue().emailTemplate){
            const templateDetails: NotificaitonEmailTemplateModel = this.emailDetailsForm.getRawValue().emailTemplate;
            this.attachments = this.attachments.filter(attachment=> attachment.id);
            this.attachments.map(attachment=>{
                attachment.statusId = Status.Deleted;
            });

            this.emailDetailsForm.patchValue({
                subject: templateDetails.templateSubject,
                body: templateDetails.templateBody,
                isAttachedDetail: templateDetails.isEnclosureRequired
            });
            this.notificationBody = templateDetails.templateBody;
            this.loadContentInEditor(this.notificationBody);
            this.updatedAddedTags();
            this.getEmailTemplateDetails(templateDetails);
        }
    }

    getEmailTemplateDetails(templateDetails: NotificaitonEmailTemplateModel){
        this.appMainService.isShowSpinner('getEmailTemplate');
        this.emailTemplateService.getEmailTemplateById(templateDetails.id,templateDetails.statusId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.appMainService.isHideSpinner('getEmailTemplate');
                if(response?.notificationTemplateAttachments?.length>0){
                    response?.notificationTemplateAttachments.filter(attachment=>attachment.statusId==Status.Active).map(attachment=>{
                        this.attachments.push({
                            ...attachment,
                            id: 0,
                            oldAttachment: attachment.attachment,
                            attachment: {...attachment.attachment,id: 0},
                            workflowActionEmailId: this.emailDetailsForm.getRawValue().id
                        })
                    })
                }
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('getEmailTemplate');
                this.messageService.add({ severity: 'error', summary: 'Error', detail: `Failed to load ${this.emailTypeName} Template Information!` });
            }
        })
    }

    selectTemplateField($event){
        const selectedField: any = $event.value;

        if(selectedField?.childGroup || !selectedField) return;

        if(this.selectedInsertField=='subject'){
            // const cursorPosition = this.getSubjectCursorPosition();
            const subjectText = this.emailDetailsForm.getRawValue().subject;
            const insertedText = `${subjectText} [${selectedField.name.trim()}]`;
            this.emailDetailsForm.patchValue({
                subject: insertedText
            })
        }else{
            if(this.editor){
                const _quill = this.editor.getQuill();

                const selection = _quill.getSelection(true);
                const fieldText: string = ` [${selectedField.name.trim()}] `;
                _quill.insertText(selection?.index||0, fieldText);
                this.emailDetailsForm.patchValue({
                    body: _quill.root.innerHTML
                });
                this.notificationBody =  _quill.root.innerHTML;
                this.loadContentInEditor(this.notificationBody);
                const nextCursorPoint = (selection?.index||0)+(fieldText.length-1);

                setTimeout(()=>{
                    _quill.setSelection(nextCursorPoint,0);
                },200)
            }
        }

        setTimeout(()=>{
            this.selectedType = null;
            this.updatedAddedTags();
        },200)
    }

    onEditorTextChange($event: any){
        this.emailDetailsForm.patchValue({
            body: $event.htmlValue
        })
    }

    getSubjectCursorPosition(){
        const cursorPosition = {
            start: 0,
            end: 0
        }

        if(this.emailSubject){
            cursorPosition.start = this.emailSubject?.selectionStart||0;
            cursorPosition.end = this.emailSubject?.selectionEnd||0;
        }

        return cursorPosition;
    }

    //Load Dropdown Value
    loadDropdownValues(){
        this.activeUsers = this.app.usersList.filter(obj => obj.statusId == 1);
        this.getAllSMTPList();
        // this.getWhatsAppBusiness();
        this.getUserTree();
    }

    getAllEmailTemplates(){
        this.workflowService.getEmailTemplates(this.selectedModule?.objectId,this.selectedChannelId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.emailTemplateList = response||[];

                if(this.selectedActionEmail && this.selectedActionEmail.emailTemplateId && !this.emailDetailsForm.getRawValue().emailTemplate){
                    const templateDetails: NotificaitonEmailTemplateModel = this.emailTemplateList.find(template=> template.id == this.selectedActionEmail.emailTemplateId)||null;
                    this.emailDetailsForm.patchValue({
                        emailTemplate: templateDetails
                    });
                }
            }
        })
    }

    getAllSMTPList(){
        this.configurationService.getAllVendorSMTPRegistration().pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.smtpList = response||[];
                const defaultSMTP = this.smtpList.find(smtp=> smtp?.isDefault);

                if(!this.emailDetailsForm.getRawValue().from && defaultSMTP){
                    this.emailDetailsForm.patchValue({
                        from: defaultSMTP
                    })
                }
            }
        })
    }

    getWhatsAppBusiness(){
        this.chatFacade.getBusinessAccounts().pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.whatsAppBusinessAccounts = response
                    .filter((a) => a.registered && a.isActive)
                    .map((a) => ({
                        id: a.id,
                        name: a.name,
                        label: `${a.name} (${a.phoneNumber})`,
                        value: a.id,
                        isDefault: a.isDefault,
                    }));
                const defaultContact = this.whatsAppBusinessAccounts.find(contact=> contact?.isDefault);

                if(!this.emailDetailsForm.getRawValue().whatsappFrom && defaultContact){
                    this.emailDetailsForm.patchValue({
                        whatsappFrom: defaultContact
                    })
                }
            }
        })
    }

    // Scroll to error handler function
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }

    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    openFilePreview(file: any): void {
        this.displayFilePreview = true;

        const attachment = file?.oldAttachment ?  file?.oldAttachment :  file?.attachment;

        this.currentFile = {
            ...attachment,
            downloadLink: file.attachment?.content ? file.attachment.content : file?.filePath
        };
    }

    closeFilePreview() {
        this.displayFilePreview = false;
    }

    downloadFile(name: string, content: string, attachmentId: number) {
        let ext = name.substring(name.lastIndexOf('.') + 1);
        ext = ext?.toLowerCase();
        let mime_type = this.mimeTypes.filter(el => el.extension === ext);
        if (mime_type.length > 0 && content) {
            const base64 = content;
            const mime = mime_type[0].value;
            const blob = this.dataURItoBlob(base64, mime);
            const file = new File([blob], name, { type: mime });
            saveAs(file, name)
        } else if(attachmentId>0){
            this.appMainService.isShowSpinner('downloadLink');
            this.documentsService.downloadPublicFile(attachmentId,true).subscribe({
                next:(data)=>{
                    this.downloadedFile(data?.downloadLink);
                    this.appMainService.isHideSpinner('downloadLink');
                },
                error:(error: any)=>{
                    this.appMainService.isHideSpinner('downloadLink');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: "Error occurred while download this file...",
                    });
                }
            })
        }else{
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: "No content found to download...",
            });
        }
    }

    dataURItoBlob(dataURI: string, mimeType: string) {
        const kept = dataURI.split(",", 2);
        const byteString = atob(kept[1]);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: mimeType });
        return blob;
    }

    downloadedFile(url:string){
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = 'todo-1.json';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }

    openFileNewTab(attachmentDetails: any){
        if(attachmentDetails?.id>0){

            this.appMainService.isShowSpinner('openFilePreview');
            let docType = attachmentDetails.name.substring(attachmentDetails.name.lastIndexOf('.') + 1);
            docType = docType?.toLowerCase();

            this.documentsService.downloadPublicFile(attachmentDetails.id,false).subscribe({
                next:(data)=>{
                    switch (docType) {
                        case 'docx':
                        this.documentViewerService.selectDocumentType(docType,data?.encodedDownloadLink);
                        break;
                        case 'xlsx':
                            this.documentViewerService.selectDocumentType(docType,data?.encodedDownloadLink);
                          break;
                        case 'pptx':
                            this.documentViewerService.selectDocumentType(docType,data?.encodedDownloadLink);
                          break;
                        case 'csv':
                            this.documentViewerService.selectDocumentType(docType,data?.encodedDownloadLink);
                          break;
                        case 'pdf':
                            this.documentViewerService.selectDocumentType(docType,data?.downloadLink);
                          break;
                        case 'jpg':
                            this.documentViewerService.selectDocumentType(docType,data?.downloadLink);
                          break;
                          case 'png':
                            this.documentViewerService.selectDocumentType(docType,data?.downloadLink);
                          break;
                          case 'gif':
                            this.documentViewerService.selectDocumentType(docType,data?.downloadLink);
                          break;
                          case 'txt':
                            this.documentViewerService.selectDocumentType(docType,data?.downloadLink);
                          break;
                        default:
                            this.documentViewerService.selectDocumentType(docType,data?.downloadLink);
                      }
                      this.appMainService.isHideSpinner('openFilePreview');
                },
                error:(error: any)=>{
                    this.appMainService.isHideSpinner('openFilePreview');
                    this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: "Error occurred while open this file...",
                  });
                  }
            })
        }
    }

    setEmailUsers(){
        if(this.selectedActionEmail?.workflowActionEmailList?.length>0){
            const assignType = this.selectedActionEmail.workflowActionEmailList.find(user=>user.statusId==Status.Active);
            const assignedType = this.assignedTypes.find(c=>c.id==assignType?.assignedType)||this.assignedTypes[0];
            const assignedIds: any[] = [];
            const ccAssignedIds: any[] = [];
            const bccAssignedIds: any[] = [];
            let assignedList = this.getFlatArrayFormChilren(this.activeUserTree)||[];
            let assignedListForCcBcc = assignedList;
            if([WorkflowModelsNS.WorkflowEmailAssignedType.Contact].includes(assignedType?.id)){
                assignedList = this.contactAssignTypes;
            }
            // For sent To
            this.selectedActionEmail.workflowActionEmailList?.filter(userDetails=> userDetails.statusId==Status.Active).map(userDetails=>{
                const selected = assignedList.find(user=>user.id==userDetails.assignedId && userDetails.emailNotificationType==this.workflowEmailRecipientType.TO);
                if(selected) assignedIds.push(selected);
            });

            // For  CC
            this.selectedActionEmail.workflowActionEmailList?.filter(userDetails=> userDetails.statusId==Status.Active).map(userDetails=>{
                const selected = assignedListForCcBcc.find(user=>user.id==userDetails.assignedId && userDetails.emailNotificationType==this.workflowEmailRecipientType.CC);
                if(selected) {
                    ccAssignedIds.push(selected)
                    this.emailDetailsForm.patchValue({
                        assignedUsersCc: ccAssignedIds
                    });
                };
            });

            // For  BCC
            this.selectedActionEmail.workflowActionEmailList?.filter(userDetails=> userDetails.statusId==Status.Active).map(userDetails=>{
                const selected = assignedListForCcBcc.find(user=>user.id==userDetails.assignedId && userDetails.emailNotificationType==this.workflowEmailRecipientType.BCC);
                if(selected){
                    bccAssignedIds.push(selected)
                    this.emailDetailsForm.patchValue({
                        assignedUsersBcc: bccAssignedIds
                    });
                };
            });

            if([WorkflowModelsNS.WorkflowEmailAssignedType.User,WorkflowModelsNS.WorkflowEmailAssignedType.Contact].includes(assignedType?.id)){
                this.emailDetailsForm.patchValue({
                    assignedUsers: assignedIds
                })
            }
        }
    }

    getUserTree(){
        this.configurationService.getAllUserOrgChartData(this.app.userId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                if(response){
                    this.activeUserTree = this.copyUserTree(response);

                    if(this.selectedActionEmail?.workflowActionEmailList?.length>0){
                        this.setEmailUsers();
                    }else{
                        const userList = this.getFlatArrayFormChilren(this.activeUserTree)||[];
                        const selectedUser = userList.find(user=>user.id==this.app.userId);

                        if(selectedUser && WorkflowModelsNS.WorkflowEmailAssignedType.User==this.emailDetailsForm.getRawValue().assignedType?.id){
                            this.emailDetailsForm.patchValue({
                                assignedUsers: [selectedUser]
                            })
                        }
                    }
                }
            },
            error: (error)=>{

            }
        })
    }

    onUserSelect($event: any, field: string) {
        let selectedUsers = this.emailDetailsForm.getRawValue()[field] || [];
        const exist = selectedUsers.find(x => x.id == $event?.node?.id);

        if (exist || !$event?.node?.id) {
            setTimeout(() => {
                this.emailDetailsForm.patchValue({
                    [field]: selectedUsers
                }, { onlySelf: true, emitEvent: false });
            });
        }
    }

    copyUserTree(originalTree: Array<object>): Array<object> {
        return originalTree.map(({ childUsers, ...data }: any) => ({
            id: data.id,
            label: `${data.name}${data?.role ? (data.name ? ' - ' : '') + data?.role : ''}`,
            name: data.name,
            children: this.copyUserTree(childUsers)
        }));
    }

    getFlatArrayFormChilren(members: any[]){
        let children = [];
        return members.map(m => {
          if (m.children && m.children.length) {
            children = [...children, ...m.children];
          }
          return m;
        }).concat(children.length ? this.getFlatArrayFormChilren(children) : children);
    }

    //Include Saved Search
    newSavedSearchRule(){
        this.selectedSavedSearchIndex = -1;
        this.selectedSavedSearch = null;
        this.displaySavedSearchRule = true;
    }

    closeSavedSearchRulesDialog(){
        this.selectedSavedSearchIndex = -1;
        this.selectedSavedSearch = null;
        this.displaySavedSearchRule = false;
    }

    addSavedSearchRules(savedSearchDetails: {
        selectedSavedSearch: SavedSearchNS.ISavedSearchOverview,
        addedRules: SavedSearchNS.IRuleList[]}
    ){
        const mainModule = savedSearchDetails.addedRules.find(rule=> rule.isMainModule);

        const savedSearch: WorkflowModelsNS.WorkflowEmailSavedSearchs = {
            id: 0,
            workflowActionEmailId: this.selectedActionEmail?.id||0,
            objectId: savedSearchDetails.selectedSavedSearch?.objectId,
            objectName: mainModule?.objectName||"",
            channelId: savedSearchDetails.selectedSavedSearch?.channelId,
            channelName: mainModule?.template?.templateName||"",
            saveSearchId: savedSearchDetails.selectedSavedSearch?.id,
            saveSearchName: savedSearchDetails.selectedSavedSearch?.name,
            statusId: Status.Active
        }

        if(this.addedSavedSearch?.length>0){
            this.addedSavedSearch[0] = {
                ...savedSearch,
                id: this.addedSavedSearch[0].id
            };
        }else{
            this.addedSavedSearch.push(savedSearch)
        }
    }

    modifySelectedSavedSearch(savedSearch: WorkflowModelsNS.WorkflowEmailSavedSearchs, index: number){
        this.selectedSavedSearchIndex = index;
        this.selectedSavedSearch = savedSearch;
        this.displaySavedSearchRule = true;
    }

    removeSavedSearch(savedSearch: WorkflowModelsNS.WorkflowEmailSavedSearchs, index: number){
        if(savedSearch.id>0){
            savedSearch.statusId = Status.Deleted;
        }else{
            this.addedSavedSearch.splice(index,1);
        }

    }

    addedActiveSavedSearch(){
        return this.addedSavedSearch.filter(s=> s.statusId==Status.Active);
    }

    setEditorDefaultType(){
        if(this.editor){
            const _quill = this.editor.getQuill();
            if(this.notificationType==WorkflowModelsNS.WorkflowNotificationTypeEnum.WHATSAPP){
                _quill.formatLine(0, _quill.getLength(), { 'code-block': true });
                this.notificationBody = "";
            }else{
                _quill.removeFormat(0, _quill.getLength());
            }
        }
    }

    showGenerateEmailDialog(): void {
        this.visibleEmailGenerationScenario = true;
    }

    setGeneratedEmail(generatedData: {subject: string, body: string}){
        this.emailDetailsForm.patchValue({
            subject: generatedData.subject
        });
        this.loadContentInEditor(generatedData.body,true);
    }

    closeGenerateDialog(){
        this.visibleEmailGenerationScenario = false;
    }

    //#region Quill Table
    initEditorModules(){
        const backgroundColors: string[] = EDITOR_COLORS;
        const globalThis = this;
        this.editorModules = {
            table: false,
            'better-table-plus': {
                operationMenu: {
                    items: {
                        unmergeCells: {
                            text: 'Unmerge cells'
                        },
                        // markDynamicRow: {
                        //     text: 'Mark/Unmark Dynamic Row',
                        //     iconSrc: TABLE_ROW_DOWN_ICON,
                        //     handler() {
                        //         if(this.tableSelection?.selectedTds?.length>0){
                        //             const rowNode = this.tableSelection?.selectedTds[0]?.parent?.domNode;
                        //             if(rowNode){
                        //                 const currentId = rowNode.getAttribute('id');

                        //                 if (currentId === 'email-template-table-dynamic-row') {
                        //                     globalThis.renderer.removeAttribute(rowNode, 'id');
                        //                 } else {
                        //                     globalThis.renderer.setAttribute(rowNode, 'id', 'email-template-table-dynamic-row');
                        //                 }

                        //                 this.quill.update(Quill.sources.USER);
                        //                 this.tableSelection.clearSelection();
                        //                 globalThis.loadContentInEditor(this.quill.root.innerHTML,true);
                        //             }
                        //         }
                        //     }
                        // }
                    },
                    color: {
                        colors: backgroundColors,
                        text: 'Background'
                    }
                }
            }
        }
    }

    insertTable(){
        let quill = this.editor.getQuill();
        quill.focus();
        const tableModule = quill.getModule('better-table-plus');
        tableModule.insertTable(2, 5)
    }

    loadContentInEditor(text: any, updateSelf: boolean = false){
        if(updateSelf){
            this.notificationBody = text;
        }
        setTimeout(()=>{
            const _quill = this.editor.getQuill();
            const editorContainer = _quill.root;
            this.renderer.setProperty(editorContainer, 'innerHTML', text);
        })
    }
    //#endregion Quill Table End
}
